export const OTP_ERROR_MAX_SUBMISSIONS = 'MAX_SUBMISSIONS_REACHED' as const;

export function isMaxSubmissionsReached(result: {
  ok: false;
  code?: string;
}): boolean {
  return result.code === OTP_ERROR_MAX_SUBMISSIONS;
}
